export default __webpack_public_path__ + "static/media/close.89c18ef2.svg";